<template>
    <div class="main partner">
        <div class="head">
            <!-- <span>畜牧帮区域合伙人智能运营指挥中心</span>
            <div class="icon">
                <span class="el-icon-user"></span>
                <span @click="exitLogin" class="el-icon-switch-button"></span>
            </div> -->
            <div class="left">
                <!-- 时间 -->
                <div class="timer">
                    <div class="model_item">
                        {{ time }}
                    </div>
                    <div class="model_item_1">
                        <span>{{ current }}</span>
                        <span>{{ week | weekFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="center">
                <span>{{ headerInfo.name }}</span>
            </div>
            <div class="right">
                <div class="icon">
                    <span @click="exitLogin" class="el-icon-switch-button"></span>
                    <span @click="exitLogin">退出</span>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div class="top">
                    <div class="server">
                        <!-- <span class="card"></span> -->
                        <span class="card_">服务客户概览</span>
                        <img src="../../assets/hhr_right.png" alt="">
                    </div>
                    <div class="add">
                        <div class="add_item">
                            <span class="num">{{ serveCustomerView.monthNewlyCustomer }}</span>
                            <div>
                                <span>本月新增客户(家)</span>
                                <span :class="{ active_1: serveCustomerView.flag === 0 }">月环比 <i>{{
                                        serveCustomerView.linkRadio + '%'
                                }}</i> </span>
                                <img v-if="serveCustomerView.flag === 1" src="../../assets/icon_down_1.png" alt="">
                                <img v-if="serveCustomerView.flag === 0" src="../../assets/icon_up_1.png" alt="">
                            </div>
                        </div>
                        <div class="add_item">
                            <span class="num">{{ serveCustomerView.todayNewlyCustomer }}</span>
                            <span>昨日新增客户(人)</span>
                        </div>
                    </div>
                    <!-- <div id="pieChart"></div> -->
                    <div class="pie_box">
                        <dv-active-ring-chart @mouseenter="pieEnter" @mouseout="pieOver" :config="config1"
                            id="pieChart" />
                        <div class="pie_legend">
                            <div style="margin-top:.15rem" v-for="(item, i) in pieData" :key="i">
                                <span class="pie_border"></span> <span style="cursor: pointer;">{{ item.name }}</span>
                                <span style="cursor: pointer;width:.6rem;margin-left: .1rem;">{{ ((item.value / sum) *
                                        100).toFixed(2)
                                        + '%'
                                }}</span> <span style="cursor: pointer;margin-left: .1rem;">{{ item.value + '家'
}}</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="footer">
                    <div class="server">
                        <!-- <span class="card"></span> -->
                        <span class="card_">畜牧科技师概览</span>
                        <img src="../../assets/hhr_right.png" alt="">
                    </div>
                    <div class="add">
                        <div class="add_item">
                            <span class="num">{{ farmerView.monthNewly }}</span>
                            <div>
                                <span>本月新增(人)</span>
                                <span :class="{ active_1: farmerView.flag === 0 }">月环比 <i>{{ farmerView.linkRadio + '%'
                                }}</i> </span>
                                <img v-if="farmerView.flag === 1" src="../../assets/icon_down_1.png" alt="">
                                <img v-if="farmerView.flag === 0" src="../../assets/icon_up_1.png" alt="">
                            </div>
                        </div>
                        <!-- <div class="add_item">
                            <span class="num">{{ farmerView.todayNewly }}</span>
                            <span>今日新增(人)</span>
                        </div> -->
                    </div>
                    <div class="server">
                        <div style="display: flex;align-items: center;">
                            <span class="card"></span>
                            <span class="card_1">畜牧科技师服务能力TOP10</span>
                        </div>
                        <div class="date">
                            <span @click="serviceStatusBtn('day')"
                                :class="{ active: serviceStatus === 'day' }">近30日</span>
                            <span @click="serviceStatusBtn('month')"
                                :class="{ active: serviceStatus === 'month' }">近3月</span>
                            <span @click="serviceStatusBtn('all')"
                                :class="{ active: serviceStatus === 'all' }">近6月</span>
                        </div>
                    </div>
                    <!-- :row-class-name="tableRowClassName" @row-click='rowClick' -->
                    <!-- @mouseenter="tableMouseOver" @mouseleave="tableMouseOut" -->
                    <!-- <el-table class="marquee" @mouseenter="tableMouseOver" @mouseleave="tableMouseOut"
                        style="margin-top:0.46rem;overflow: hidden;padding: 0 .05rem 0 .2rem;" ref='table'
                        :data="tableData" height="3.5rem" :row-style="{ height: '5px' }" :cell-style="{ padding: '0' }"
                        align="center" header-align="center" :destroy-on-close="true">
                        <el-table-column show-overflow-tooltip align="center" property="name" min-width="30" label="">
                        </el-table-column>
                        <el-table-column show-overflow-tooltip align="center" property="name" min-width="80" label="姓名">
                        </el-table-column>
                        <el-table-column show-overflow-tooltip property="name" align="center" min-width="80"
                            label="服务区域">
                        </el-table-column>
                        <el-table-column show-overflow-tooltip align="center" property="name" min-width="70"
                            label="服务客户">
                        </el-table-column>
                        <el-table-column show-overflow-tooltip align="center" property="name" min-width="100"
                            label="客户交易额(万)">
                        </el-table-column>
                    </el-table> -->
                    <!-- <div class="content" style="display: block;">
                        <div class="head">
                            <span class="col"></span>
                            <span class="col">姓名</span>
                            <span class="col">服务区域</span>
                            <span class="col">服务客户</span>
                            <span class="col">客户交易额(万)</span>
                        </div>
                        <div class="marquee-view">
                            <div class="marquee">
                                <div class="row" v-for='(item, i) in tableData' :key="i">
                                    <span class="col cols">{{ item.serialNo }}</span>
                                    <span class="col">{{ item.name }}</span>
                                    <span class="col">{{ item.serviceArea }}</span>
                                    <span class="col">{{ item.serviceCustomer }}</span>
                                    <span class="col">{{ item.tradeAmount }}</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div style="width:6.25rem;height:4rem;">
                        <dv-scroll-board :config="config" style="width:6.25rem;height:3.7rem;margin-top: .3rem;" />
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="top">
                    <div class="top_">
                        <div class="top_item">
                            <span>累计服务客户(家)</span>
                            <span>{{ middleTop.totalServeCustomer }}</span>
                            <div class="top_box"></div>
                        </div>
                        <div class="top_item">
                            <span>畜牧科技师(人)</span>
                            <span>{{ middleTop.livestockMaster }}</span>
                            <div class="top_box"></div>
                        </div>
                        <div class="top_item">
                            <span>当前存栏活畜(头)</span>
                            <span>{{ middleTop.liveAnimal }}</span>
                            <div class="top_box"></div>
                        </div>
                        <div class="top_item">
                            <span>累计综合交易金额(万)</span>
                            <span>{{ middleTop.totalTradeAmount }}</span>
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div id="mapBox"></div>
                </div>
                <div class="footer">
                    <div class="server">
                        <!-- <span class="card"></span> -->
                        <span class="card_">存栏活畜分布</span>
                        <img src="../../assets/hhr_right.png" alt="">
                        <!-- <div class="date">
                            <span>牛</span>
                            <span>羊</span>
                        </div> -->
                    </div>
                    <div class="distribution">
                        <div class="cattle">
                            <span>{{ cattleStatus === 'cattle' ? '牛' : '羊' }}只存栏量{{ cattleStatus === 'cattle' ? '(头)'
                                    : '(只)'
                            }}</span>
                            <span>{{ cowSheep.breedingStock }}</span>
                            <!-- <span>{{ liveAnimalDis.sheep['breedingStock'] }}</span> -->
                        </div>
                        <div class="cattle">
                            <span>{{ cattleStatus === 'cattle' ? '母牛存栏量' : '' }}{{ cattleStatus === 'cattle' ? '(头)'
                                    : ''
                            }}</span>
                            <!-- <span>{{ cowSheep.bossyBreedingStock ? cowSheep.bossyBreedingStock :
                                    cowSheep.eweBreedingStock
                            }}</span> -->
                            <span>{{ cowSheep.bossyBreedingStock ? cowSheep.bossyBreedingStock :
                                    ''
                            }}</span>
                            <!-- <span>{{ liveAnimalDis.sheep['eweBreedingStock']}}</span> -->
                        </div>
                    </div>
                    <div id="barChart2" class="bar_chart2"></div>
                    <div class="date">
                        <span @click="cattleStatusBtn('cattle')" :class="{ active: cattleStatus === 'cattle' }">牛</span>
                        <span @click="cattleStatusBtn('sheep')" :class="{ active: cattleStatus === 'sheep' }">羊</span>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="server">
                    <!-- <span class="card"></span> -->
                    <span class="card_">交易概览</span>
                    <img src="../../assets/hhr_right.png" alt="">
                </div>
                <div class="add">
                    <div class="add_item">
                        <span class="num">{{ tradeView.monthTradeAmount }}</span>
                        <div>
                            <span>本月累计交易额(万)</span>
                            <span :class="{ active_1: tradeView.flag === 0 }">月环比 <i>{{ tradeView.linkRadio + '%' }}</i>
                            </span>
                            <img v-if="tradeView.flag === 1" src="../../assets/icon_down_1.png" alt="">
                            <img v-if="tradeView.flag === 0" src="../../assets/icon_up_1.png" alt="">
                        </div>
                    </div>
                    <div class="add_item">
                        <span class="num">{{ tradeView.todayTotalAmount }}</span>
                        <span>昨日累计交易额(万)</span>
                    </div>
                </div>
                <div class="server">
                    <div style="display: flex;align-items: center;">
                        <span class="card"></span>
                        <span class="card_1">交易趋势</span>
                    </div>
                    <div class="date">
                        <span @click="statusBtn('day_')" :class="{ active: status === 'day_' }">近7日</span>
                        <span @click="statusBtn('month_')" :class="{ active: status === 'month_' }">近30日</span>
                        <span @click="statusBtn('all_')" :class="{ active: status === 'all_' }">近3月</span>
                    </div>
                </div>
                <div id="lineChart" class="line_chart"></div>
                <div class="server">
                    <div style="display: flex;align-items: center;">
                        <span class="card"></span>
                        <span class="card_1">交易额占比分布</span>
                    </div>
                    <div class="date">
                        <span @click="status_Btn('day_1')" :class="{ active: status_ === 'day_1' }">近7日</span>
                        <span @click="status_Btn('month_1')" :class="{ active: status_ === 'month_1' }">近30日</span>
                        <span @click="status_Btn('all_1')" :class="{ active: status_ === 'all_1' }">近3月</span>
                    </div>
                </div>
                <div id="ringChart"></div>
            </div>
        </div>
    </div>
</template>
  
<script>
// import datas from "./datas";
import HighCharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(HighCharts);
export default {
    components: {

    },
    data() {
        return {
            // datas: datas,
            headerInfo: {},
            userInfo: {},
            serviceStatus: 'day',
            cattleStatus: "cattle",
            status: 'day_',
            status_: 'day_1',
            // 存储表格数据
            tableData: [],
            config: {
                header: ['', '姓名', '服务区域', '服务客户', '客户交易额'],
                data: [],
            },
            config1: {
                data: [],
            },
            pieData: [],
            sum: null,
            ringChartStatus: 'month',
            optionData: [
                {
                    name: '1津窑矿',
                    y: 530,
                    h: 5
                },
                {
                    name: '天津窑矿',
                    y: 1530,
                    h: 25
                },
                {
                    name: '北京窑矿',
                    y: 2530,
                    h: 45
                },
                {
                    name: '青磁窑矿',
                    y: 3530,
                    h: 57
                }
            ],
            tradeAmountProportion: { //交易额占比分布
                "month": [  // 本月
                    { "label": "活畜交易", "value": 17.6 },
                    { "label": "商城交易", "value": 17.6 },
                    { "label": "屠宰交易", "value": 30.6 },
                ],
                "year": [ // 本年度
                    { "label": "活畜交易", "value": 17.6 },
                    { "label": "商城交易", "value": 17.6 },
                    { "label": "屠宰交易", "value": 30.6 },
                ],
                "all": [ // 全部
                    { "label": "活畜交易", "value": 17.6 },
                    { "label": "商城交易", "value": 17.6 },
                    { "label": "屠宰交易", "value": 30.6 },
                ]
            },
            region: {},
            currentLiveAnimalDistribution: '',
            time: null,
            current: null,
            week: null,
            timer: null,//定时器,
            timers: null,
            lineData: [],
            cowSheep: {},//牛羊展示
            serveCustomerView: {},// 服务客户概览
            farmerView: {},// 畜牧科技师概览
            farmerServiceAbility: {}, // 畜牧科技师服务能力TOP5
            middleTop: {},//地图上测
            liveAnimalDis: {},// 存栏活畜分布
            tradeView: {},// 交易概览
            tradeTrend: {},// 交易趋势
            tradeAmountProp: {}, // 交易额占比
            screenData: {}
        };
    },
    watch: {},
    created() {
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        this.getTime()

    },
    mounted() {
        // this.getData()
        this.getMap()
        this.pieEnter()
        this.pieOver()
    },
    // 销毁定时器
    destroyed() {
        clearInterval(this.timer)
    },
    // 日期过滤
    filters: {
        weekFilter: (val) => {
            if (val == 0) return '星期天'
            if (val == 1) return '星期一'
            if (val == 2) return '星期二'
            if (val == 3) return '星期三'
            if (val == 4) return '星期四'
            if (val == 5) return '星期五'
            if (val == 6) return '星期六'

        }
    },
    methods: {
        pieEnter() {
            this.$nextTick(() => {
                document.querySelector('#pieChart').addEventListener('mouseenter', () => {
                    this.setConfig(this.screenData, 'mouseenter')
                })
            })
        },
        pieOver() {
            this.$nextTick(() => {
                document.querySelector('#pieChart').addEventListener('mouseout', () => {
                    this.setConfig(this.screenData, 'mouseout')
                })
            })
        },
        // 畜牧科技师切换
        serviceStatusBtn(val) {
            val === 'day' ? (this.serviceStatus = 'day') && (this.tableData = this.farmerServiceAbility.thirtyDays.value) : val === 'month' ? (this.serviceStatus = 'month') && (this.tableData = this.farmerServiceAbility.threeMonth.value) : val === 'all' ? (this.serviceStatus = 'all') && (this.tableData = this.farmerServiceAbility.sixMonth.value) : (this.serviceStatus = 'day') && (this.tableData = [])
            // if (val === 'month') this.serviceStatus = 'month'
            // if (val === 'all') this.serviceStatus = 'all'

            var arr = []
            this.tableData.forEach(item => {
                arr.push([item.serialNo, item.name, item.serviceArea, item.serviceCustomer, item.tradeAmount])
                // this.config.data.push([item.serialNo, item.name,item.serviceAream,item.serviceCustomer,item.tradeAmount])
            })
            // arr.push(...arr)
            this.config = { header: ['', '姓名', '服务区域', '服务客户', '客户交易额'], data: arr, waitTime: 2000 }
            // console.log(this.config, 'config');

        },
        cattleStatusBtn(val) {
            this.$nextTick(() => {
                if (val === 'cattle') {
                    this.cattleStatus = 'cattle'
                    this.cowSheep = this.liveAnimalDis.cow
                    this.setBarData(this.liveAnimalDis.cow.dis)
                }
                if (val === 'sheep') {
                    this.cattleStatus = 'sheep'
                    this.cowSheep = this.liveAnimalDis.sheep
                    this.setBarData(this.liveAnimalDis.sheep.dis)
                    console.log(this.liveAnimalDis.sheep.dis, '232323');
                }
            })
        },
        statusBtn(val) {
            if (val === 'day_') {
                this.status = 'day_'
                this.lineData = [{ month: this.tradeTrend.sevenDay.liveAnimalTrade.label, title: '活畜交易', value: this.tradeTrend.sevenDay.liveAnimalTrade.value },
                { month: this.tradeTrend.sevenDay.mallTrade.label, title: '商城交易', value: this.tradeTrend.sevenDay.mallTrade.value },
                { month: this.tradeTrend.sevenDay.slaughterTrade.label, title: '屠宰交易', value: this.tradeTrend.sevenDay.slaughterTrade.value }
                ]
            }
            if (val === 'month_') {
                this.status = 'month_'
                this.lineData = [{ month: this.tradeTrend.thirtyDays.liveAnimalTrade.label, title: '活畜交易', value: this.tradeTrend.thirtyDays.liveAnimalTrade.value },
                { month: this.tradeTrend.thirtyDays.mallTrade.label, title: '商城交易', value: this.tradeTrend.thirtyDays.mallTrade.value },
                { month: this.tradeTrend.thirtyDays.slaughterTrade.label, title: '屠宰交易', value: this.tradeTrend.thirtyDays.slaughterTrade.value }
                ]
            }
            if (val === 'all_') {
                this.status = 'all_'
                this.lineData = [{ month: this.tradeTrend.threeMonth.liveAnimalTrade.label, title: '活畜交易', value: this.tradeTrend.threeMonth.liveAnimalTrade.value },
                { month: this.tradeTrend.threeMonth.mallTrade.label, title: '商城交易', value: this.tradeTrend.threeMonth.mallTrade.value },
                { month: this.tradeTrend.threeMonth.slaughterTrade.label, title: '屠宰交易', value: this.tradeTrend.threeMonth.slaughterTrade.value }
                ]
            }
            this.setLineData(this.lineData, 'lineChart')


        },
        status_Btn(val) {
            if (val === 'day_1') {
                this.status_ = 'day_1'
                this.setRingChart('month')
            }
            if (val === 'month_1') {
                this.status_ = 'month_1'
                this.setRingChart('year')
            }
            if (val === 'all_1') {
                this.status_ = 'all_1'
                this.setRingChart('all')
            }
        },
        setRingChart(status) {
            this.ringChartStatus = status;
            if (status === 'month') {
                this.tradeAmountProportion[status].forEach((item, i) => {
                    if (i == 0) item.value = this.tradeAmountProp.sevenDays.liveAnimalTrade
                    if (i == 1) item.value = this.tradeAmountProp.sevenDays.mallTrade
                    if (i == 2) item.value = this.tradeAmountProp.sevenDays.slaughterTrade
                })
            }
            if (status === 'year') {
                this.tradeAmountProportion[status].forEach((item, i) => {
                    if (i == 0) item.value = this.tradeAmountProp.thirtyDays.liveAnimalTrade
                    if (i == 1) item.value = this.tradeAmountProp.thirtyDays.mallTrade
                    if (i == 2) item.value = this.tradeAmountProp.thirtyDays.slaughterTrade
                })
            }
            if (status === 'all') {
                this.tradeAmountProportion[status].forEach((item, i) => {
                    if (i == 0) item.value = this.tradeAmountProp.threeMonth.liveAnimalTrade
                    if (i == 1) item.value = this.tradeAmountProp.threeMonth.mallTrade
                    if (i == 2) item.value = this.tradeAmountProp.threeMonth.slaughterTrade
                })
            }
            this.optionData = this.tradeAmountProportion[status].map(item => {
                item.name = item.label
                item.y = item.value / 3
                item.h = item.value / 3
                return item
            })
            this.ringChart()
        },
        // 3d饼图
        ringChart() {
            // 修改3d饼图绘制过程
            let each = HighCharts.each,
                round = Math.round,
                cos = Math.cos,
                sin = Math.sin,
                deg2rad = Math.deg2rad;
            HighCharts.wrap(HighCharts.seriesTypes.pie.prototype, 'translate', function (proceed) {
                proceed.apply(this, [].slice.call(arguments, 1));
                // Do not do this if the chart is not 3D
                if (!this.chart.is3d()) {
                    return;
                }
                var series = this,
                    chart = series.chart,
                    options = chart.options,
                    seriesOptions = series.options,
                    depth = seriesOptions.depth || 0,
                    options3d = options.chart.options3d,
                    alpha = options3d.alpha,
                    beta = options3d.beta,
                    z = seriesOptions.stacking ? (seriesOptions.stack || 0) * depth : series._i * depth;
                z += depth / 2;
                if (seriesOptions.grouping !== false) {
                    z = 0;
                }
                each(series.data, function (point) {
                    var shapeArgs = point.shapeArgs,
                        angle;
                    point.shapeType = 'arc3d';
                    var ran = point.options.h;
                    shapeArgs.z = z;
                    shapeArgs.depth = depth * 0.75 + ran;
                    shapeArgs.alpha = alpha;
                    shapeArgs.beta = beta;
                    shapeArgs.center = series.center;
                    shapeArgs.ran = ran;
                    angle = (shapeArgs.end + shapeArgs.start) / 2;
                    point.slicedTranslation = {
                        translateX: round(cos(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)),
                        translateY: round(sin(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad))
                    };
                });
            });
            (function (H) {
                H.wrap(HighCharts.SVGRenderer.prototype, 'arc3dPath', function (proceed) {
                    // Run original proceed method
                    var ret = proceed.apply(this, [].slice.call(arguments, 1));
                    ret.zTop = (ret.zOut + 1) / 100;
                    return ret;
                });
            }(HighCharts));

            //日总存煤量

            const offsetHeight =
                document.getElementById("ringChart").offsetHeight;
            HighCharts.chart('ringChart', {
                chart: {
                    type: 'pie',
                    // animation: false,
                    backgroundColor: 'transparent',
                    height: offsetHeight,
                    events: {
                        load: function () {
                            let each = HighCharts.each, points = this.series[0].points;
                            each(points, function (p) {
                                p.graphic.attr({
                                    translateY: -p.shapeArgs.ran
                                });
                                p.graphic.side1.attr({
                                    translateY: -p.shapeArgs.ran
                                });
                                p.graphic.side2.attr({
                                    translateY: -p.shapeArgs.ran
                                });
                            });
                        }
                    },
                    options3d: {
                        enabled: true,
                        // alpha: 50
                        alpha: 60
                    },
                },
                title: {
                    text: ''
                },
                legend: { //图例
                    itemStyle: { color: '#00E0DB' },
                    itemHoverStyle: {
                        color: '#00E0DB'
                    },
                    // labelFormatter: () => {
                    //     console.log(this);
                    //         return this.name
                    // }
                    labelFormat: '{name}',
                    symbolHeight: 8,
                    symbolWidth: 8,
                    symbolRadius: 4
                },
                tooltip: {
                    enabled: false,
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow',
                    },
                    borderColor: 'rgba(18, 36, 132, 1)',
                    borderWidth: 2,
                    textStyle: {
                        color: '#fff',
                    },
                    formatter: (item) => {
                        console.log(item)
                    }
                },
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        // allowPointSelect: true,
                        cursor: 'pointer',
                        center: ['50%', '60%'],
                        // size: 180,
                        // innerSize: 100,
                        size: 150,
                        innerSize: 100,
                        colors: ['#0085FE', '#00E2FC', '#00C6FC', '#00E2FC'],
                        // dataLabels: {
                        //     enabled: true,
                        //     format: '{point.name}{point.percentage:.1f}%'
                        // },
                        showInLegend: true,//重点图例显示
                    }
                },
                series: [
                    {
                        name: '青磁窑矿',
                        data: this.optionData,
                        showInLegend: true,
                        dataLabels: {
                            crop: false,
                            padding: -10,
                            shadow: true,
                            style: {
                                fontSize: '12px',
                                color: "#fff",
                            },
                            formatter: function () {
                                return '<p style="color: #FFFFFF">' + this.key + '' + (this.y / this.total * 100).toFixed(2) + '%</p>';
                            },
                        },
                    }
                ]
            })
        },
        // 退出
        exitLogin() {
            window.localStorage.removeItem('mapfileUrl')
            window.localStorage.removeItem('NMYDATAUSERINFO')
            window.localStorage.removeItem('NMYDATAASSTSTOKEN')
            this.$router.push({ path: '/nmlogin' })
        },
        getTime() {
            this.current = new Date().toLocaleDateString().replace(/\//g, '-');//获取当前日期（“年/月/日”）
            this.week = new Date().getDay();//获取当前星期（0~6，0代表星期天）
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                var time = new Date().toLocaleTimeString();//获取当前时间
                this.time = time
            }, 1000)
        },
        setLineData(data, dom) {
            const colors = ['#106BDC', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "8%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        // console.log(params, 'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].seriesName + '(万)' + ':'}${params[0].value
                            }</p><br/>
                         <p style="font-size: 14px; font-weight: normal;">${params[1].seriesName + '(万)' + ':'}${params[1].value}</p><br/>
                         <p style="font-size: 14px; font-weight: normal;">${params[2].seriesName + '(万)' + ':'}${params[2].value}</p>
                         `;
                        // return params.name
                    },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '金额(万)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 4],
                    },
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 牛羊只存栏柱状图
        setBarData(data) {
            // for(var i=0;i<data.value.length;i++){
            //     for(var j=i;j<data.value.length-i;j++){

            //     }
            // }
            // console.log(data,'data');
            // data.value.sort((a, b) => {
            //     return (b - a)
            // })
            this.chart = this.$echarts.init(document.getElementById('barChart2'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        // console.log(params,'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        if (params[0].name.indexOf("牛") != -1) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">存栏数量： ${params[0].value || 0} 头 </span>
                         </p>`;
                        } else {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">存栏数量： ${params[0].value || 0} 只 </span>
                         </p>`;
                        }

                        // return params.name
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '20%',
                    // 20
                    left: '3%',
                    right: '4%',
                    bottom: '1%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data.label,
                },
                yAxis: {
                    // name: '数量(头)',
                    name: this.cattleStatus == "cattle" ? '数量(头)' : '数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 4],
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00E0DB'
                    },
                    itemStyle: {
                        opacity: 0.8,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "#00E0DB"
                    },
                    data: data.value,
                },
            }
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 环状图
        pieChart(data) {
            var sum = 0
            Object.values(data).forEach((item) => {
                return sum = sum + item
            }, 0)
            var myChart = this.$echarts.init(document.getElementById('pieChart'));
            var option = {
                // color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF'],

                title: {
                    show: true,
                    left: '45%',
                    top: '40%',
                    text: `共计(家)\n\n ${sum}`,
                    textStyle: {
                        color: '#FFFFFF',
                        fontWeight: 500,
                        fontSize: 12
                    },
                },
                grid: {
                    top: '10%',
                    bottom: '20%',
                    left: 10,
                    right: 10,
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow',
                    },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    formatter: '{b} {d}%\n\n'
                },
                legend: {
                    top: '23%',
                    right: '7%',
                    icon: 'circle',
                    // formatter: function (name) {
                    //     if (name == '商城交易') return `${name}  ${data.mallTrade + '%'}`
                    //     if (name == '活畜交易') return `${name}  ${data.liveTrade + '%'}`
                    //     if (name == '屠宰交易') return `${name}  ${data.slaughterTrade + '%'}`
                    // },
                    textStyle: {
                        color: '#00E0DB',
                        fontWeight: 400,
                        fontFamily: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC'
                    },
                    orient: 'vertical',
                    itemGap: 20
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['50%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center',
                            color: '#FFFFFF',
                            alignTo: 'labelLine'
                        },
                        // labelLine: {
                        //     show: true,
                        //     length: 5,
                        //     length2: 100,
                        //     lineStyle: {
                        //         color: '#73c0de',
                        //     }
                        // },
                        data: [
                            { value: data.unitFarmer, name: '个体养殖户' },
                            { value: data.majorFarmer, name: '专业养殖户' },
                            { value: data.smallFarm, name: '小型养殖户' },
                            { value: data.largeFarm, name: '大型养殖户' },
                        ]
                    }
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        getData() {
            this.$http({
                // url: 'screenapp-service/baseBigScreen/select',
                url: 'screenapp-service/screenRegionalPartner/select',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    // deptId: "1585954770193145858",
                    parentId: "0",
                    menuMark: "1"
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.screenData = screenData
                    this.headerInfo = {
                        name: data.result.screenName
                    }
                    // console.log(screenData);
                    this.serveCustomerView = screenData.serveCustomerView
                    this.farmerView = screenData.farmerView
                    this.farmerServiceAbility = screenData.farmerServiceAbility
                    // this.tableData = screenData.farmerServiceAbility.thirtyDays.value
                    this.serviceStatusBtn('day')
                    // console.log(this.tableData, '232323');
                    this.middleTop = screenData.middleTop
                    this.liveAnimalDis = screenData.liveAnimalDis
                    this.cowSheep = screenData.liveAnimalDis.cow
                    console.log(screenData);
                    this.tradeView = screenData.tradeView
                    this.lineData = [{ month: screenData.tradeTrend.sevenDay.liveAnimalTrade.label, title: '活畜交易', value: screenData.tradeTrend.sevenDay.liveAnimalTrade.value },
                    { month: screenData.tradeTrend.sevenDay.mallTrade.label, title: '商城交易', value: screenData.tradeTrend.sevenDay.mallTrade.value },
                    { month: screenData.tradeTrend.sevenDay.slaughterTrade.label, title: '屠宰交易', value: screenData.tradeTrend.sevenDay.slaughterTrade.value }
                    ]
                    this.tradeTrend = screenData.tradeTrend
                    this.tradeAmountProp = screenData.tradeAmountProp
                    // this.pieChart(screenData.customerTypeDis)
                    this.setConfig(screenData, 'mouseout')
                    // console.log(screenData.customerTypeDis, 'screenData.customerTypeDis');
                    this.setLineData(this.lineData, 'lineChart')
                    this.setBarData(screenData.liveAnimalDis.cow.dis)
                    this.setRingChart(this.ringChartStatus)
                    this.draw(this.region, screenData.ArealDis.mapData)
                    // this.currentLiveAnimalDistribution = Object.keys(screenData.liveAnimalDistribution[0])[0]
                    // this.changedrewData(screenData.liveAnimalDistribution)
                } else {
                    // this.$message.error(data);
                }
            })
        },
        setConfig(screenData, a) {
            this.$nextTick(() => {
                var pieArr = [{ value: screenData.customerTypeDis.unitFarmer, name: '个体养殖户' },
                { value: screenData.customerTypeDis.familyFarm, name: '家庭农场' },
                { value: screenData.customerTypeDis.farmer, name: '牧户' },
                { value: screenData.customerTypeDis.largeFarm, name: '大型牧场' },]
                this.sum = 0
                if (a === 'mouseenter') {
                    this.config1 = {}
                    this.config1 = {
                        data: pieArr, color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                        radius: '65%',
                        activeRadius: '70%',
                        digitalFlopStyle: {
                            fontSize: 20
                        },
                        showOriginValue: true,
                        activeTimeGap: 10000
                    }
                }
                if (a === 'mouseout') {
                    this.config1 = {}
                    this.config1 = {
                        data: pieArr, color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                        radius: '65%',
                        activeRadius: '70%',
                        digitalFlopStyle: {
                            fontSize: 20
                        },
                        showOriginValue: true,
                        activeTimeGap: 2000
                    }
                }
                setTimeout(() => {
                    var colorArr = ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF']
                    document.querySelectorAll('.pie_border').forEach((item, i) => {
                        item.style.display = 'inline-block'
                        item.style.width = .1 + 'rem'
                        item.style.height = .1 + 'rem'
                        item.style.borderRadius = '50%'
                        item.style.backgroundColor = colorArr[i]

                    })
                }, 100)
                pieArr.forEach(item => {
                    this.sum += item.value
                })
                this.pieData = pieArr
            })
        },
        changedrewData(data) {
            data.forEach(item => {
                if (item[this.currentLiveAnimalDistribution]) {
                    this.draw(this.region, item[this.currentLiveAnimalDistribution])
                }
            })
        },
        // 地图
        draw(geoJson, data) {
            data.forEach(item => {
                item.value = item.totalServeCustomer
            })
            // console.log(data, 'data');
            // console.log(geoJson,'123');
            // 基于准备好的dom，初始化echarts实例
            // document.getElementById("mapBox").innerHTML = ''
            // console.log(data)
            var chart = this.$echarts.init(document.getElementById("mapBox"));
            // geoJson.features.forEach((item) => {
            //     item['properties']['cp'] = item.properties.center
            // })
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            chart.hideLoading();
            var option = {
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 'params');
                        return `
                        <p style="color:#00E0DB;font-size: 20px;">${params.name}</p><br/>
                        <p>
                       <span style="color: #FFF; font-size: 14px; font-weight: normal;">累计服务客户<span style="color: #00E0DB; font-size: 16px;">${params.data.totalServeCustomer || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">家</span> </span>
                              </p><br/>
                              <p>
                                  <span style="color: #FFF; font-size: 14px; font-weight: normal;">畜牧科技师<span style="color: #00E0DB; font-size: 16px;">${params.data.livestockMaster || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">人</span> </span>
                  
                              </p><br/>
                              <p>
                                  <span style="color: #FFF; font-size: 14px; font-weight: normal;">当前存栏活畜<span style="color: #00E0DB; font-size: 16px;">${params.data.liveAnimal || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">头</span> </span>
                  
                              </p><br/>
                              <p>
                                  <span style="color: #FFF; font-size: 14px; font-weight: normal;">累计综合交易金额<span style="color: #00E0DB; font-size: 16px;">${params.data.totalTradeAmount || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">万</span> </span>
                  
                              </p>
                              `;
                        // return params.name
                    },
                },
                grid: {
                    // top: '-5%',
                    // show:true
                },
                series: [
                    {
                        type: "map3D", // 系列类型
                        name: "map3D", // 系列名称
                        zoom: 1,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data,
                        top: '-10%',
                        // bottom:'50%',
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 12, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                            // align: 'center',
                            // verticalAlign: 'middle'
                            // normal: {
                            //     show: true,
                            //     color: 'rgba(5, 176, 220, 1)',
                            //     fontSize: 1, //此处字体需做兼容适配

                            //     align: 'left',
                            //     verticalAlign: 'middle',
                            //     position: 'inside',
                            //     distance: 15,
                            // },
                            // emphasis: {
                            //     show: true,
                            //     color: '#ececec'
                            // }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            color: "rgba(33,80,231,1)", // 地图板块的颜色
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: true,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter : function(params) {
                                //     console.log(params)
                                // }
                            },
                            itemStyle: {
                                "color": "#00E0DB"
                            }
                        },
                        groundPlane: {
                            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                            show: false, // 是否显示地面。[ default: false ]
                            color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                        },
                        light: {
                            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                            main: {
                                // 场景主光源的设置，在 globe 组件中就是太阳光。
                                color: "#fff", //主光源的颜色。[ default: #fff ]
                                intensity: 1.2, //主光源的强度。[ default: 1 ]
                                shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                                shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                                alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                                beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                            },
                        },

                        viewControl: {
                            // 用于鼠标的旋转，缩放等视角控制。
                            projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                            autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                            rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                            zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                            panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            orthographicSize: 60,
                            // distance: 200, 
                            distance: 90, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                            alpha: 25, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                            beta: 80, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
                            minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                            maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                            minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                            maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                            center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                            animation: true, // 是否开启动画。[ default: true ]
                            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                            animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                        },
                    },
                ],
                visualMap: {
                    type: 'piecewise',
                    // show: true,
                    // min: 0,
                    // max: 200, //控制根据返回值  控制数量
                    right: 15,
                    bottom: 0,
                    // showLabel: !0,
                    // text: ['High', 'Low'],
                    // realtime: false,
                    // calculable: true,
                    // // inRange: {
                    // //     color: ['#11366a', '#EFFFA8', '#EFFFA8', '#FC8506', '#F1411D']  //显示颜色
                    // // },
                    // continuous: {
                    //     type: 'piecewise',
                    itemSymbol: 'circle',
                    itemWidth: 8,
                    itemHeight: 8,
                    textStyle: { color: '#fff' },
                    pieces: [{
                        gt: 400,
                        label: "400以上",
                        // color: "#6b3e35"
                        color: "#39a177"
                    }, {
                        gte: 301,
                        lte: 400,
                        label: "301 - 400",
                        color: "#55b9b5"
                        // color: "#4a383f"
                    }, {
                        gte: 201,
                        lte: 300,
                        label: "201- 300",
                        color: "#439faa"
                        // color: "#303345"
                    }, {
                        gte: 101,
                        lte: 200,
                        label: "101- 200",
                        color: '#3c9b9b'
                        // color: "#192f4d"
                    }, {
                        gte: 0,
                        lte: 100,
                        label: "0 - 100",
                        // color: "#112e50"
                        color: "#238e62"
                    }],
                    // },



                },
                // legend: {

                // }

            };
            chart.clear();
            chart.setOption(option)
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    // deptId: "1585954770193145858",
                },
            }).then(res => {
                if (res.data.code === 200) {
                    this.region = res.data.result.json;
                    this.getData()
                }
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    // position: relative;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // background-color: #030E27;
    background: url('../../assets/bg-hhr.png');
    background-size: 100% 100%;

    .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // padding: 0 .38rem;
        width: 100%;
        height: 1rem;
        // background: linear-gradient(270deg, rgba(2, 13, 38, 0.84) 10%, #003841 60%);
        opacity: 1;

        .left {
            width: 8.43rem;
            height: 100%;
            background: url('../../assets/left.png');
            background-size: 100% 100%;
            position: relative;

            .timer {
                position: absolute;
                // left: 1.04rem;
                left: .5rem;
                top: .35rem;
                display: flex;
                justify-content: center;
                align-items: center;

                .model_item {
                    // width: 1.7rem;
                    // height: 0.52rem;
                    font-size: 0.38rem;
                    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                    font-weight: bold;
                    color: #fff;
                    cursor: pointer;
                }

                .model_item_1 {
                    width: 2.76rem;
                    height: 0.27rem;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 0.3rem;
                    margin-left: .5rem;

                    span:nth-child(2) {
                        margin-left: .2rem;
                    }
                }
            }
        }

        .center {
            width: 7.72rem;
            height: 100%;
            background: url('../../assets/middle.png');
            background-size: 100% 100%;
            text-align: center;
            line-height: 1rem;

            span {
                font-size: 0.38rem;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #00E0DB;

            }
        }

        .right {
            width: 8.43rem;
            height: 100%;
            background: url('../../assets/right.png');
            background-size: 100% 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .icon {
                span {
                    font-size: 0.25rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    cursor: pointer;
                    padding-right: .13rem;
                }

                span:nth-child(2) {
                    padding-right: .5rem;
                }
            }
        }

    }

    .content {
        display: flex;
        width: 100%;
        height: 12.25rem;
        margin: .25rem auto 0;
        padding: 0 .26rem .25rem;


        .left {
            width: 6.25rem;
            // background-color: #00E0DB;

            .top {
                height: 5rem;
                background: linear-gradient(90deg, rgba(0, 222, 217, 0.1) 5%, rgba(0, 223, 218, 0) 60%);
                border-left: 0.005rem solid rgba(0, 224, 219, 0.3);
                opacity: 1;

                .server {
                    position: relative;


                    img {
                        position: absolute;
                        left: 1.8rem;
                        top: 0.15rem;
                    }

                }

                .pie_box {
                    display: flex;
                    width: 6.25rem;
                    height: 3.2rem;
                    margin-top: 0.2rem;

                    #pieChart {
                        width: 3rem;
                        max-height: 3.2rem;
                        margin-left: 0.3rem;
                        cursor: pointer;
                    }

                    .pie_legend {
                        flex: 1;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        // align-items: center;
                        justify-content: center;

                        span {
                            display: inline-block;
                            font-size: 0.13rem;
                            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                            font-weight: 400;
                            color: #00E0DB;
                            line-height: 0.25rem;
                        }

                        // span:nth-child(2) {
                        //     padding-left: .1rem;
                        // }
                        span:nth-child(2) {
                            min-width: 1.1rem;
                        }

                        // span:nth-child(3) {
                        //     width: .4rem;

                        // }
                        // span:nth-child(4) {
                        //     width: .4rem;
                        //     padding-left: .08rem;
                        // }
                    }
                }


            }

            .footer {
                position: relative;
                height: 6.75rem;
                // background: linear-gradient(90deg, rgba(0, 223, 218, 0.15) 5%, rgba(0, 223, 218, 0.01) 88%);      
                background: linear-gradient(72deg, rgba(0, 223, 218, 0.1) 10%, rgba(0, 223, 218, 0.00) 88%);
                opacity: 1;
                // border-left: 0.005rem solid #00E0DB;
                border-left: 0.005rem solid rgba(0, 224, 219, 0.3);
                margin-top: .24rem;

                .server {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    // margin-top: .6rem;
                    padding-top: .6rem;

                    .card_1 {
                        font-size: 0.2rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        // font-weight: bold;
                        color: #00E0DB;
                        margin-left: .2rem;
                    }

                    img {
                        position: absolute;
                        left: 2rem;
                        top: 0.15rem;
                    }

                }

                .server:nth-child(1) {

                    padding-top: 0;

                }

            }
        }

        .center {
            width: 10.5rem;
            margin: 0 .24rem;
            display: flex;
            flex-direction: column;

            .top {
                flex: 1;
                // background: linear-gradient(180deg, rgba(1, 34, 54, 0.27) 32%, rgba(1, 34, 54, 0.98) 100%);
                // opacity: 1;

                .top_ {
                    display: flex;
                    justify-content: space-between;

                    .top_item {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        width: 2.25rem;
                        height: 1.45rem;
                        background: rgba(0, 224, 219, 0.08);
                        opacity: 1;
                        cursor: pointer;

                        // margin-left: .54rem;
                        &::after {
                            position: absolute;
                            left: 0;
                            top: 0;
                            content: "";
                            width: .13rem;
                            height: .13rem;
                            border-left: 1px solid rgba(0, 224, 219, 0.3);
                            ;
                            border-top: 1px solid rgba(0, 224, 219, 0.3);
                            ;

                        }

                        &::before {
                            position: absolute;
                            right: 0;
                            top: 0;
                            content: "";
                            width: .13rem;
                            height: .13rem;
                            border-right: 1px solid rgba(0, 224, 219, 0.3);
                            ;
                            border-top: 1px solid rgba(0, 224, 219, 0.3);
                            ;

                        }

                        .top_box {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 1rem;

                            &::after {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                content: "";
                                width: .13rem;
                                height: .13rem;
                                border-left: 1px solid rgba(0, 224, 219, 0.3);
                                ;
                                border-bottom: 1px solid rgba(0, 224, 219, 0.3);
                                ;

                            }

                            &::before {
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                content: "";
                                width: .13rem;
                                height: .13rem;
                                border-right: 1px solid rgba(0, 224, 219, 0.3);
                                ;
                                border-bottom: 1px solid rgba(0, 224, 219, 0.3);
                                ;

                            }
                        }

                        span:nth-child(1) {
                            min-width: 1.55rem;
                            font-size: 0.2rem;
                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                            font-weight: 500;
                            color: #00E0DB;
                            text-align: center;
                            line-height: 0.3rem;
                        }

                        span:nth-child(2) {
                            min-width: 1.55rem;
                            text-align: center;
                            font-size: 0.38rem;
                            font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                            font-weight: 800;
                            color: #FFE11D;
                            line-height: 0.35rem;
                            margin-top: .15rem;
                        }
                    }

                    .top_item:hover {
                        // background-color:red
                        // box-shadow:5px 5px 10px #1d394c;
                        // transition: all .5s linear;
                        margin-top: 0px;
                        /*和hover的margin-top有对比，原无30,现在0，相当于上移了,30px*/
                        // box-shadow: 2px 2px 2px 2px #918f8f;
                        /*盒子阴影*/
                        background: rgba(0, 224, 219, 0.1);
                        box-shadow: 0rem 0rem 0.25rem 0rem rgba(30, 231, 231, 0.4), inset 0rem 0rem 0.25rem 0rem rgba(30, 231, 231, 0.4);
                        opacity: 1;
                        transform: translateY(-5px);
                        transition: all 0.5s;
                        /*持续时间*/

                    }

                }

                #mapBox {
                    width: 10.5rem;
                    height: 5rem;
                    // margin-top: .5rem; 
                }
            }


            .footer {
                position: relative;
                height: 4.65rem;
                background: linear-gradient(180deg, rgba(1, 34, 54, 0.0) 10%, rgba(1, 34, 54, 0.3) 90%);
                // background: linear-gradient(180deg, rgba(1, 34, 54, 0.1) 20%, rgba(1, 34, 54, 0.48) 80%);
                border-bottom: 0.005rem solid rgba(0, 224, 219, 0.3);
                opacity: 1;
                margin-top: .15rem;

                .server {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    // padding-top: .24rem;

                    .date {
                        margin-left: 0;

                        span {
                            padding: .05rem .2rem;
                            cursor: pointer;
                        }

                        span:nth-child(2) {
                            margin: 0 .13rem;
                        }
                    }

                    img {
                        position: absolute;
                        left: 1.8rem;
                        top: 0.15rem;
                    }
                }

                .distribution {
                    display: flex;
                    margin-left: .25rem;
                    margin-top: .35rem;

                    .cattle {
                        width: 50%;

                        span:nth-child(1) {
                            min-width: 1.3rem;
                            height: 0.18rem;
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular,
                                Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 0.18rem;
                        }



                        span:nth-child(2) {
                            min-width: 0.53rem;
                            height: 0.43rem;
                            font-size: 0.3rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #00E0DB;
                            line-height: 0.43rem;
                            margin-left: .15rem;
                        }
                    }

                    .cattle:nth-child(2) {
                        // margin-left: 2.84rem;
                    }
                }

                .bar_chart2 {
                    width: 100%;
                    height: 3rem;
                    padding: 0 0.2rem;
                    margin-top: 0.29rem;
                }

                .date {
                    // margin-left: 1.2rem;
                    color: #00E0DB;
                    position: absolute;
                    top: .15rem;
                    right: 0;

                    span {
                        padding: .05rem .2rem;
                        font-size: 0.13rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        background: rgba(255, 255, 255, 0.05);
                        opacity: .5;
                        font-weight: 400;
                        cursor: pointer;
                    }

                    span:nth-child(2) {
                        margin: 0 .13rem;
                    }
                }
            }

        }

        .right {
            width: 6.25rem;
            height: 12rem;
            // background: linear-gradient(-90deg, rgba(0, 223, 218, 0.1) 8%, rgba(0, 223, 218, 0.1) 38%, rgba(0, 223, 218, 0) 80%);
            background: linear-gradient(-78deg, rgba(0, 223, 218, 0.08) 8%, rgba(0, 223, 218, 0.1) 38%, rgba(0, 223, 218, 0) 80%);
            opacity: 1;
            // border-right: 0.005rem solid #00E0DB;
            border-right: 0.005rem solid rgba(0, 224, 219, 0.3);


            .server {
                display: flex;
                justify-content: space-between;
                align-items: center;
                // margin-top: .6rem;
                padding-top: .89rem;
                // padding-top: .57rem;
                position: relative;

                .card_ {
                    width: 6.25rem;
                    height: 0.48rem;
                    text-align: left;
                    padding-left: .15rem;
                    background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 70%);
                }

                .card_1 {
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    // font-weight: bold;
                    color: #00E0DB;
                    margin-left: .2rem;
                }

                img {
                    position: absolute;
                    left: 1.4rem;
                    top: 0.15rem;
                }

            }

            .server:nth-child(1) {

                padding-top: 0;

            }


            .line_chart {
                width: 100%;
                // height: 4.5rem;
                height: 3.9rem;
                padding-right: .2rem;
            }

            #ringChart {
                width: 100%;
                height: 4.1rem;
            }
        }

        .server {
            display: flex;
            justify-content: space-between;
            align-items: center;
            // padding-top: .24rem;

            .card {
                display: inline-block;
                width: 0.11rem;
                height: 0.2rem;
                background: #00E0DB;
                opacity: 1;
                margin-left: .25rem;
            }

            .card_ {
                width: 6.25rem;
                height: 0.48rem;
                line-height: .48rem;
                font-size: 0.2rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 88%);
                opacity: 1;
                color: #00E0DB;
                padding-left: .15rem;
            }

            .date {
                // margin-left: 1.2rem;
                color: #00E0DB;
                padding-right: 0.15rem;

                span {
                    padding: .05rem;
                    font-size: 0.13rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    background: rgba(255, 255, 255, 0.05);
                    opacity: .5;
                    font-weight: 400;
                    cursor: pointer;
                }

                span:nth-child(2) {
                    margin: 0 .13rem;
                }
            }
        }

        .active {
            opacity: 1 !important;
        }

        .add {
            display: flex;
            margin-top: .48rem;
            margin-left: .3rem;

            .add_item {
                display: flex;
                flex-direction: column;
                margin-right: 0.2rem;

                .num {
                    display: block;
                    font-size: 0.38rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;
                    line-height: 0.38rem;
                }

                div,
                span:nth-child(2) {
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 0.18rem;
                    padding-top: .1rem;

                    span:nth-child(2) {
                        margin-left: .16rem;
                        font-size: 0.15rem;
                        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                        font-weight: 500;
                        color: #FF5A0D;
                        line-height: 0.18rem;

                        i {
                            font-style: normal;
                        }
                    }

                    img {
                        margin-left: .1rem !important;
                    }
                }

                div {
                    min-width: 3rem;
                }

            }

            .add_item:nth-child(2) {
                // margin-left: 1rem;
            }
        }

        .active_1 {
            color: #00FF9D !important;
        }

        // .content {
        //     position: relative;
        //     display: none;
        //     max-height: 4rem;
        // }

        // .head {
        //     display: flex;
        //     justify-content: space-between;
        //     line-height: .5;
        //     // line-height: 1.05;
        //     background-color: rgba(255, 255, 255, 0.1);
        //     padding: 0.15rem 0.25rem;
        //     font-size: 0.18rem;
        //     font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        //     font-weight: 500;
        //     color: #00E0DB;
        //     height: .44rem;
        // }

        // .marquee-view {
        //     position: absolute;
        //     top: 0.5rem;
        //     bottom: 0;
        //     width: 90%;
        //     overflow: hidden;
        // }

        // .cols {
        //     color: #FFC300 !important;

        // }

        // .row {
        //     width: 100%;
        //     display: flex;
        //     justify-content: space-between;
        //     align-items: center;
        //     height: .44rem;
        //     line-height: .5;
        //     font-size: 0.15rem;
        //     color: #FFFFFF;
        //     padding: 0.4rem 0 0.4rem .3rem;

        //     span {
        //         // text-align: center;
        //         // padding: 0 .2rem;
        //     }
        // }

        // .row .icon-dot {
        //     position: absolute;
        //     left: 0.2rem;
        //     opacity: 0;
        // }

        // .row:hover {
        //     background-color: rgba(255, 255, 255, 0.1);
        //     color: #68d8fe;
        // }

        // .row:hover .icon-dot {
        //     opacity: 1;
        // }

        // .col {
        //     width: 1rem;
        // }

        // .col:first-child {
        //     width: .6rem;
        // }

        // .col:nth-child(5) {
        //     width: 1.5rem;
        // }

        // /* 通过CSS3动画滚动marquee */
        // .marquee-view .marquee {
        //     animation: move 15s linear infinite;
        // }

        // @keyframes move {
        //     0% {}

        //     100% {
        //         transform: translateY(-50%);
        //     }
        // }

        // /* 3.鼠标经过marquee 就停止动画 */
        // .marquee-view .marquee:hover {
        //     animation-play-state: paused;
        // }
    }
}
</style>
<style lang="scss">
.partner {
    .header {
        min-width: 6.25rem;
        background-color: #013346 !important
    }

    // DataV
    .header-item {
        // width: 1.2rem !important;
        opacity: .85;
        color: #00E0DB;
    }

    .header-item:last-child {
        width: 1.8rem !important;

    }

    .header-item:nth-child(2) {
        // width: 1.2rem !important;
        color: #00E0DB;
        padding-left: .3rem;

    }

    .rows {
        padding: .2rem 0 .4rem 0;
    }

    .row-item {
        background: transparent !important;
    }

    .ceil {
        width: 1.2rem !important;
        text-align: center !important;
        padding-right: .1rem !important;
    }

    .ceil:first-child {
        color: #FFC300;
    }

    .ceil:nth-child(2) {
        padding-left: .25rem !important;
        text-align: left !important;
    }

    .ceil:last-child {
        text-align: right !important;
    }

    .ceil:nth-child(3) {
        margin-left: -0.05rem !important;
        text-align: left !important;
    }

    .active-ring-name {
        padding-top: .1rem;
    }
}

@media only screen and (max-width: 1900px) {
    .header {
        width: 100%;
    }

    .header-item {
        font-size: 8px !important;
    }

    .header-item:last-child {
        // width: 2.5rem !important;
        // background: #013346;
        // opacity: 1;
    }

    .dv-digital-flop,
    .active-ring-name {
        font-size: 12px !important;
    }
}
</style>